var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 212,
    viewBox: "0 0 203 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_2645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.618 106.847V1H159.962H83.2863H0V149.759V211.067H116.924V149.759H124.288H159.962H201.605V106.847H160.618Z",
    fill: "#57E79B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7656 1.23779H0.697266V58.166H91.7656V1.23779Z",
    fill: "#D3EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.622 150.01H0.725586V211.305H117.622V150.01Z",
    fill: "#2ACE6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.639 12.167H115.67V47.5977H138.639V12.167Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 22.3735C111.025 22.012 109.436 20.3712 109.436 18.4105C109.436 16.4499 111.011 14.8369 113.103 14.4614L113.145 22.3735H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 33.5395C111.025 33.178 109.436 31.5372 109.436 29.5765C109.436 27.6159 111.011 26.0029 113.103 25.6274L113.145 33.5395H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 44.7192C111.025 44.3577 109.436 42.7169 109.436 40.7562C109.436 38.7956 111.011 37.1826 113.103 36.8071L113.145 44.7192H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 36.8071C143.283 37.1687 144.873 38.8095 144.873 40.7701C144.873 42.7308 143.297 44.3438 141.205 44.7192L141.163 36.8071H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 25.6274C143.283 25.989 144.873 27.6298 144.873 29.5904C144.873 31.5511 143.297 33.1641 141.205 33.5395L141.163 25.6274H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 14.4614C143.283 14.823 144.873 16.4638 144.873 18.4244C144.873 20.3851 143.297 21.9981 141.205 22.3735L141.163 14.4614H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.161 12.167V47.5977",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.639 57.832H115.67V93.2627H138.639V57.832Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 68.0244C111.025 67.6629 109.436 66.0221 109.436 64.0614C109.436 62.1008 111.011 60.4877 113.103 60.1123L113.145 68.0244H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 79.2046C111.025 78.843 109.436 77.2022 109.436 75.2416C109.436 73.2809 111.011 71.6679 113.103 71.2925L113.145 79.2046H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 90.3843C111.025 90.0227 109.436 88.3819 109.436 86.4213C109.436 84.4606 111.011 82.8476 113.103 82.4722L113.145 90.3843H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 82.4722C143.283 82.8337 144.873 84.4745 144.873 86.4352C144.873 88.3958 143.297 90.0088 141.205 90.3843L141.163 82.4722H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 71.2925C143.283 71.654 144.873 73.2948 144.873 75.2555C144.873 77.2161 143.297 78.8291 141.205 79.2046L141.163 71.2925H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 60.1123C143.283 60.4738 144.873 62.1147 144.873 64.0753C144.873 66.036 143.297 67.649 141.205 68.0244L141.163 60.1123H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.161 57.832V93.2488",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.639 103.497H115.67V138.928H138.639V103.497Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 113.689C111.025 113.328 109.436 111.687 109.436 109.726C109.436 107.766 111.011 106.153 113.103 105.777L113.145 113.689H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 124.87C111.025 124.508 109.436 122.867 109.436 120.907C109.436 118.946 111.011 117.333 113.103 116.958L113.145 124.87H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.131 136.049C111.025 135.688 109.436 134.047 109.436 132.086C109.436 130.126 111.011 128.513 113.103 128.137L113.145 136.049H113.131Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 128.137C143.283 128.499 144.873 130.14 144.873 132.1C144.873 134.061 143.297 135.674 141.205 136.049L141.163 128.137H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 116.958C143.283 117.319 144.873 118.96 144.873 120.921C144.873 122.881 143.297 124.494 141.205 124.87L141.163 116.958H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.177 105.777C143.283 106.139 144.873 107.78 144.873 109.74C144.873 111.701 143.297 113.314 141.205 113.689L141.163 105.777H141.177Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.161 103.497V138.914",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4023 131.767V149.663",
    stroke: "#1F2C56",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5283 131.419C50.8206 131.419 59.1604 139.734 59.1604 149.996",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.458 40.2837V58.1798",
    stroke: "#1F2C56",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.584 39.936C50.8762 39.936 59.216 48.2514 59.216 58.5135",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.917 131.767V149.663",
    stroke: "#1F2C56",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7912 131.419C67.499 131.419 59.1592 139.734 59.1592 149.996",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4019 58.5276H0.697266V1.23779H91.7656V58.5276H59.2153",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8793 150.01H117.622V211.305H0.697266V150.01H40.4019",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7656 11.5972V89.8839",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.124 150.01H202.302V107.099H161.301V1.23779H83.9834",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7268 191.865C68.7705 191.865 76.9125 186.866 76.9125 180.699C76.9125 174.532 68.7705 169.533 58.7268 169.533C48.6831 169.533 40.541 174.532 40.541 180.699C40.541 186.866 48.6831 191.865 58.7268 191.865Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2363 169.797C54.2363 166.988 56.2446 164.708 58.727 164.708C61.2094 164.708 63.2176 166.988 63.2176 169.797",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4896 175.679C39.9276 173.343 40.346 170.339 42.424 168.963C44.502 167.586 47.4306 168.379 48.9926 170.729",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9033 170.715C69.4653 168.379 72.4079 167.586 74.472 168.963C76.536 170.339 76.9544 173.343 75.3924 175.679",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5487 191.518C62.5487 194.326 60.5405 196.607 58.058 196.607C55.5756 196.607 53.5674 194.326 53.5674 191.518",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2813 185.635C76.8433 187.971 76.4249 190.975 74.347 192.352C72.269 193.728 69.3403 192.936 67.7783 190.586",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8673 190.599C47.3053 192.936 44.3627 193.728 42.2987 192.352C40.2346 190.975 39.8163 187.971 41.3782 185.635",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4713 162.024H0.697266V201.613H23.4713V162.024Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6754 77.4526H19.9014V117.041H42.6754V77.4526Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8379 19.5093H13.6396V35.3335H78.8379V19.5093Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.697266 33.1504V164.708",
    stroke: "#1F2C56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.767 101.203C15.6611 100.841 14.0713 99.2003 14.0713 97.2396C14.0713 95.279 15.6472 93.666 17.7391 93.2905L17.781 101.203H17.767Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.303 113.022H186.418V143.808H202.303V113.022Z",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.418 128.401H202.303",
    stroke: "#1F2C56",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_2645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 203,
    height: 212,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.2725f36728633653952f8848e738dc90.svg";
export { ForwardRef as ReactComponent };